import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function TermsOfService() {
    return (
        <main className="pt-24 pb-16 px-6 md:px-12 lg:px-24 min-h-dvh" data-testid="terms-page">
            <div className="max-w-3xl mx-auto">
                <Link to="/genz-credit-scoring" className="inline-flex items-center gap-2 text-text-secondary hover:text-text-primary text-sm mb-8">
                    <ArrowLeft size={16} /> Back
                </Link>
                <div className="flex items-center gap-3 mb-4">
                    <ShieldCheck size={28} className="text-cyan-signal" />
                    <p className="text-xs uppercase tracking-[0.3em] text-cyan-signal font-semibold">Legal</p>
                </div>
                <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-text-primary mb-4">
                    Terms of Service
                </h1>
                <p className="text-text-secondary text-sm leading-relaxed mb-8">
                    These terms explain the current acceptable use of GenZ Credit Score while the product is in pilot and production-hardening mode.
                </p>

                <div className="space-y-7 text-sm leading-relaxed text-text-secondary">
                    <section>
                        <h2 className="text-text-primary font-semibold mb-2">Use of the Service</h2>
                        <p>Use the service only for your own profile or for users who have explicitly authorized you to review their score.</p>
                    </section>
                    <section>
                        <h2 className="text-text-primary font-semibold mb-2">Alternative Score Notice</h2>
                        <p>GenZ Credit Score is an alternative credit assessment signal. It is not a replacement for a regulated bureau score.</p>
                    </section>
                    <section>
                        <h2 className="text-text-primary font-semibold mb-2">Evidence and Consent</h2>
                        <p>You control which evidence sources are submitted. Self-declared or demo data may carry lower confidence than verified sources.</p>
                    </section>
                    <section>
                        <h2 className="text-text-primary font-semibold mb-2">Documents</h2>
                        <p>Until secure document storage is enabled, upload controls may save only file metadata. Do not upload sensitive originals unless the interface explicitly confirms secure storage.</p>
                    </section>
                    <section>
                        <h2 className="text-text-primary font-semibold mb-2">Contact</h2>
                        <p>For privacy, deletion, or product questions, use the contact details in the Privacy Policy.</p>
                    </section>
                </div>
            </div>
        </main>
    );
}
